import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import EnterpriseHero from './components/EnterpriseHero';
import ExpertiseComparison from './components/ExpertiseComparison';
import CorpsMetier from './components/CorpsMetier';
import ProjectManagement from './components/ProjectManagement';
import EnterpriseCTA from './components/EnterpriseCTA';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Entreprise Générale Construction Rénovation Neuenegg - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Meyrin",
      "addressRegion": "Genève",
      "addressCountry": "CH"
    }
  },
  "areaServed": ["Genève", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Entreprise générale à Genève et en Suisse romande. Gestion de projets de construction, rénovation, coordination des corps de métier CVSE.",
  "serviceType": "Entreprise générale construction",
  "url": `${import.meta.env.VITE_SITE_URL}/entreprise-generale`
};

export default function EntrepriseGenerale() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Entreprise Générale Neuenegg | Construction Rénovation CVSE Suisse Romande - CasaReNovaPlus"
        description="CasaReNovaPlus : entreprise générale à Neuenegg et en Suisse romande. Gestion de projets construction, rénovation, coordination corps de métier CVSE. Devis gratuit."
        keywords="entreprise générale Genève, construction Genève, rénovation Genève, gestion projet construction Suisse romande, maître d'oeuvre Genève, coordination travaux Vaud Lausanne"
        canonical={`${import.meta.env.VITE_SITE_URL}/entreprise-generale`}
        schema={schema}
      />
      <Header />
      <EnterpriseHero />
      <ExpertiseComparison />
      <CorpsMetier />
      <ProjectManagement />
      <EnterpriseCTA />
      <Footer />
    </div>
  );
}
